import { usePage } from "@inertiajs/react"

import AppleIcon from "@/components/icons/AppleIcon"
import GoogleIcon from "@/components/icons/GoogleIcon"
import { Button } from "@/components/ui/button"
import type { SharedData } from "@/types"

type Provider = "google_oauth2" | "apple"

interface OAuthButtonProps {
  provider: Provider
  action?: "sign_in" | "sign_up"
  lastUsed?: boolean
}

const providerConfig: Record<
  Provider,
  { name: string; icon: React.ComponentType<{ className?: string }> }
> = {
  google_oauth2: {
    name: "Google",
    icon: GoogleIcon,
  },
  apple: {
    name: "Apple",
    icon: AppleIcon,
  },
}

export default function OAuthButton({
  provider,
  action = "sign_in",
  lastUsed = false,
}: OAuthButtonProps) {
  const config = providerConfig[provider]
  const Icon = config.icon
  const actionText = action === "sign_up" ? "Sign up" : "Sign in"
  const { csrf_token } = usePage<SharedData>().props

  return (
    <form action={`/auth/${provider}`} method="post" className="relative">
      <input type="hidden" name="authenticity_token" value={csrf_token} />
      <Button type="submit" variant="outline" className="w-full">
        <Icon className="size-4" />
        {actionText} with {config.name}
      </Button>
      {lastUsed && (
        <span className="bg-bg-body text-bone-muted border-border absolute -top-2 right-3 rounded border px-1.5 py-0.5 text-xs">
          Last used
        </span>
      )}
    </form>
  )
}
